module.exports = __webpack_public_path__ + "static/media/schody42 - schody drewniane nakladane.b4b95f2d.jpg";